module.exports = __webpack_public_path__ + "img/154.06dd2579.jpg";